import useCommon from '@utils/hooks/common';
import {useEffect, useState} from 'react';
import {formatCompactNumber, pause} from '@utils/index';
import PopupContainer from '@components/layout/PopupContainer';
import GradientButton from '@components/GradientButton';
import {useRouter} from 'next/router';
import {getGameEventV3} from '@constant/game';
import styles from './styles';

// import Poker from '@components/Poker';
// import classnames from 'classnames';

interface TournamentReEntryModalSheetProps {
  isModalSheetOpen: boolean;
  onModalSheetClose: () => void;
  tournamentName: string;
  tournamentId: number;
  tournamentTicketFee: number;
  roomCode: string;
}

const GAME_EVENTS = getGameEventV3();

const TournamentReEntryModalSheet = (props: TournamentReEntryModalSheetProps): JSX.Element => {
  const {
    isModalSheetOpen,
    onModalSheetClose,
    tournamentName,
    tournamentId,
    tournamentTicketFee,
    roomCode,
  } = props;

  const {classes, t, system, user, socket} = useCommon({
    withStyles: {styles, hasProps: true, props},
    withTranslation: ['tournament'],
    observers: ['system', 'user', 'socket'],
  });

  const [reEntryLoading, setReEntryLoading] = useState(false);

  useEffect(() => {
    console.log('[TournamentReEntryModalSheet.roomCode] changed', roomCode);
  }, [roomCode]);

  useEffect(() => {
    if (!isModalSheetOpen) {
      setReEntryLoading(false);
    }
  }, [isModalSheetOpen]);

  useEffect(() => {
    system?.on('reEntryOnClose', (tournamentIdArg: number) => {
      console.log(
        'reEntryOnClose',
        tournamentIdArg,
        tournamentId,
        typeof tournamentIdArg,
        typeof tournamentId
      );
      if (tournamentIdArg === tournamentId) {
        onModalSheetClose();
      }
    });

    return () => {
      system?.off('reEntryOnClose');
    };
  }, [system, tournamentId]);

  useEffect(() => {
    if (!isModalSheetOpen) {
      setReEntryLoading(false);
    }
  }, [isModalSheetOpen]);
  

  const router = useRouter();

  const seeResults = () => {
    console.log('seeResults');
    onModalSheetClose();
    router.push({
      pathname: '/tournament',
      query: {
        tournamentId,
        showResult: true,
      },
    });
    system?.hideGameOverlay();
  };

  const onReEntry = async () => {
    if (!roomCode) {
      console.warn('Cannot re-enter tournament: roomCode is undefined');
      return;
    }

    try {
      console.log('TournamentReEntryModalSheet.onReEntry', tournamentId, roomCode, user?.playerId);
      setReEntryLoading(true);
      await socket.call(GAME_EVENTS.TOURNAMENT.TOURNAMENT_RE_ENTRY, {
        data: {tournamentId, roomCode, playerId: user?.playerId},
      });
      await pause(2000);
      setReEntryLoading(false);
    } catch (err) {
      setReEntryLoading(false);
    } finally {
      setReEntryLoading(false);
    }
  };

  return (
    <PopupContainer
      visible={isModalSheetOpen}
      onCancel={onModalSheetClose}
      title={t('tournament:re_entry_modal.title')}
      mobileModalProps={{snapPoints: [570, 0]}}
    >
      <div className={classes.container}>
        <div className={classes.topSection}>
          <img height={200} src="/images/tournament/re_entry.svg" />
          <div style={{textAlign: 'center', lineHeight: '1.5'}}>
            {t('tournament:re_entry_modal.description', {
              tournamentName,
              ticketFee: formatCompactNumber(tournamentTicketFee),
            })}
          </div>
        </div>
        <div className={classes.bottomSection}>
          <GradientButton
            loading={reEntryLoading}
            disabled={!roomCode}
            style={{height: 50}}
            className={classes.closeButton}
            onClick={() => onReEntry()}
          >
            {t('tournament:re_entry_modal.re_enter')}
          </GradientButton>
          <GradientButton
            isBlue={false}
            style={{height: 50}}
            className={classes.closeButton}
            onClick={seeResults}
          >
            {t('tournament:re_entry_modal.view_tournament')}
          </GradientButton>
        </div>
      </div>
    </PopupContainer>
  );
};

export default TournamentReEntryModalSheet;
